import { GamesForTab } from 'api/mockSportCategory';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import baseball_image from 'assets/images/category/baseball.png';
import basketball_image from 'assets/images/category/basketball.png';
import boxing from 'assets/images/category/boxing.png';
import cricket from 'assets/images/category/cricket.png';
import esports from 'assets/images/category/esport.png';
import football_image from 'assets/images/category/football.png';
import golf from 'assets/images/category/golf.png';
import hockey_image from 'assets/images/category/hockey.png';
import mma from 'assets/images/category/mma.png';
import soccer_image from 'assets/images/category/soccer.png';
import tennis from 'assets/images/category/tennis.png';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import TurboButton from 'components/Commons/TurboButton';
import { IMG_ALT } from 'consts/app';
import React, { Fragment } from 'react';
import { platformStates } from 'redux/platformSlice';
import { checkMoreSportActiveWithTab, checkTabCricket, checkTabSoccer } from 'utils/commonUtils';
import { selectGames } from '../homeSlice';
import { Tooltip } from 'antd';
import { IoInformationCircleOutline } from 'react-icons/io5';
import MatchItem from '../components/MatchItem';
import { selectShowChatMobile } from 'redux/chatSlice';

interface SearchLayoutProps {
  games: GamesForTab;
  isLoading: boolean;
}

const images = [
  '',
  football_image,
  baseball_image,
  basketball_image,
  hockey_image,
  soccer_image,
  tennis,
  golf,
  mma,
  boxing,
  cricket,
  esports,
];

const getImg = (category: string) => {
  switch (category) {
    case 'American Football':
    case 'Football':
      return images[1];
    case 'Baseball':
      return images[2];
    case 'Basketball':
      return images[3];
    case 'Ice Hockey':
    case 'Hockey':
      return images[4];
    case 'Soccer':
      return images[5];
    case 'MMA':
      return images[8];
    case 'Tennis':
      return images[6];
    case 'Golf':
      return images[7];
    case 'Boxing':
      return images[9];
    case 'cricket':
      return images[10];
    case 'eSports':
      return images[11];
    default:
      return images[0];
  }
};

const checkEmpty = (games: GamesForTab): boolean => {
  for (const key in games) {
    if (games[key].length !== 0) return false;
  }
  return true;
};

const SearchLayout: React.FunctionComponent<SearchLayoutProps> = ({ games, isLoading }) => {
  const dispatch = useAppDispatch();
  const { isPhone, isTablet } = useAppSelector(platformStates);
  const gameLists = useAppSelector(selectGames);
  const t = useAppTranslation();
  const selectedShowChatMobile = useAppSelector(selectShowChatMobile);
  return (
    <div className="search-layout">
      {!isLoading ? (
        <Fragment>
          {gameLists && gameLists.length > 0 ? (
            <Fragment>
              {Object.keys(games).map((tab) => {
                if (games[tab].length === 0) return null;
                const isMoreSportsActive = checkMoreSportActiveWithTab(tab);
                return (
                  <div className="game-list" key={`game-list-${tab}`}>
                    <div className="game-list__header">
                      <div
                        className={`game-list__header-left game-list__header-left${
                          isMoreSportsActive ? '--single' : '--main'
                        }`}
                      >
                        <div className="tab-info">
                          <img src={getImg(games[tab][0].sport.group)} alt={IMG_ALT} />
                          <p className="p">{tab}</p>
                        </div>
                        {!isPhone && isTablet ? (
                          <div>
                            <TurboButton classes={tab === 'Futures' ? 'mr-3' : ''} />
                            <Tooltip
                              title={
                                <>
                                  {t('tooltip.doubleBet')}{' '}
                                  <strong>{t('tooltip.finalNotice')}</strong>
                                </>
                              }
                              placement="rightTop"
                              showArrow={false}
                              trigger={['click', 'touch']}
                            >
                              <IoInformationCircleOutline
                                className="w-6 h-6 grey-text-color"
                                style={{ marginLeft: '5px', alignSelf: 'center' }}
                              />
                            </Tooltip>
                          </div>
                        ) : (
                          <Tooltip
                            title={
                              <>
                                {t('tooltip.doubleBet')} <strong>{t('tooltip.finalNotice')}</strong>
                              </>
                            }
                            arrowPointAtCenter
                            placement="rightTop"
                          >
                            <span style={{ marginTop: 3 }}>
                              <TurboButton />
                            </span>
                          </Tooltip>
                        )}
                      </div>
                      <div
                        className={`game-list__header-right game-list__header-right${
                          isMoreSportsActive ? '--single' : '--main'
                        }`}
                      >
                        {!isMoreSportsActive && (
                          <div className="market">
                            <p className="p">
                              {checkTabSoccer(tab) || checkTabCricket(tab) ? 'Home' : 'Spread'}
                            </p>
                          </div>
                        )}
                        <div className="market">
                          <p className="p">
                            {checkTabSoccer(tab) || checkTabCricket(tab) ? 'Tie' : 'Money'}
                          </p>
                        </div>
                        {!isMoreSportsActive && (
                          <div className="market">
                            <p className="p">
                              {checkTabSoccer(tab) || checkTabCricket(tab) ? 'Away' : 'Total'}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="match-list">
                      <div className="match-list__body">
                        {games[tab].map((game) => (
                          <MatchItem
                            key={`game-row-${game.id}`}
                            category={game.sport.group.toLowerCase()}
                            game={game}
                            tab={tab}
                            isMoreSportsActive
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Fragment>
          ) : (
            <div className="empty">
              <EmptyTableIcon />
            </div>
          )}
        </Fragment>
      ) : (
        <div className="loading">
          <LoadingSpinner className="loading__content" />
        </div>
      )}
    </div>
  );
};

export default SearchLayout;
